import React, { Component, Fragment } from "react";

import {
  Metric,
  Error,
  formatDateFromData,
  isDateFromDataInISOFormat,
} from "./../../../Utils/Utils.js";

import SharedSocialLineChart from "./../../LineGraphs/SharedSocialLineChart/SharedSocialLineChart";

class Instagram extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => {
    const data = this.childRef
      .getExportData()
      .data.map((e) => ({ ...e, name: e.full_date || e.date || e.name }));
    return {
      data: data,
      opts: {
        type: "chart",
        date: {
          name: "name",
          // overwrites the default settings for date only when the date is in ISO format
          defined: isDateFromDataInISOFormat(data),
          format: "YYYY-MM-DDThh:mm:ssZ",
          viewFormat: "YYYY-MM-DD",
        },
        values: ["current_value", "previous_value"],
      },
    };
  };

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    let preparedData = formatDateFromData(
      this.props.data.graph.map((e) => ({ ...e, name: e.full_date || e.name })),
      null,
      "name"
    );

    return (
      <Fragment>
        <div key={"stats"} className="row mb-4">
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Impressions</h6>
            <Metric {...data.stats.impressions} size={"md"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Reach</h6>
            <Metric {...data.stats.reach} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Video Views</h6>
            <Metric {...data.stats.video_views} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Engagements</h6>
            <Metric {...data.stats.engagements} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Likes</h6>
            <Metric {...data.stats.likes} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Comments</h6>
            <Metric {...data.stats.comments} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Picture Video Engagement</h6>
            <Metric
              {...data.stats.pic_video_engagement}
              size={"sm"}
              type={"percentage"}
            />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Carousel Engagement</h6>
            <Metric
              {...data.stats.carousel_engagement}
              size={"sm"}
              type={"percentage"}
              format={"0.00%"}
            />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Story Engagement</h6>
            <Metric
              {...data.stats.story_engagement}
              size={"sm"}
              type={"percentage"}
            />
          </div>
        </div>
        <SharedSocialLineChart
          ref={(el) => (this.childRef = el)}
          data={preparedData}
          color={"#16DE85"}
        />
      </Fragment>
    );
  }
}

export default Instagram;
